"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.performSearch = exports.PERFORM_SEARCH = void 0;
var utils_1 = require("../../utils");
exports.PERFORM_SEARCH = (0, utils_1.networkActionTypes)("PERFORM_SEARCH");
exports.performSearch = (0, utils_1.networkAction)(exports.PERFORM_SEARCH, "/search");
